module.exports = __webpack_public_path__ + "static/media/blog-detail-3.037c6fb5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/blog-detail-3.jpg
// module id = 1109
// module chunks = 33